import React, { useEffect, useState, useRef } from "react";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import { LuFileText } from "react-icons/lu";
import { ChevronDown, ChevronUp, CloudCog } from "lucide-react";
import {
  MdChecklist,
  MdDashboard,
  MdOutlineNoteAlt,
  MdSupportAgent,
  MdBackup,
  MdStar,
} from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FiClipboard } from "react-icons/fi";
import { accordionData } from "../data/dataTwo";
import { BsInfoCircle, BsCheck2, BsX } from "react-icons/bs";
import {
  FaUsers,
  FaBuilding,
  FaComments,
  FaCalendarAlt,
  FaUsersCog,
  FaFileInvoiceDollar,
  FaTools,
  FaMobileAlt,
} from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import ContactInTouch from "../component/contactInTouch";
import ProofBlock from "../component/ProofBlock";
import faq from "../assets/new-images/faq.png";
import { Helmet } from "react-helmet-async";
import PricingCards from "../component/pricingCards";
import DynamicPricing from "./DynamicPricing";
import Onboard from "../OnBoard/Onboard";

export default function Pricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [isMMonthly, setIsMMonthly] = useState(true);

  const handleToggle = () => {
    setIsMonthly((prev) => !prev);
  };
  const hhandleToggle = () => {
    setIsMMonthly((prev) => !prev);
  };
  const [openTooltip, setOpenTooltip] = useState(null);
  const tooltipRef = useRef(null);

  const toggleTooltip = (id) => {
    setOpenTooltip((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setOpenTooltip(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isOpenTab, setisOpenTab] = useState(0);

  const handleTabClick = (index) => {
    setisOpenTab(index);
    if (index === 1) {
      setIsMMonthly(false);
    } else {
      setIsMMonthly(true);
    }
  };

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // console.log("aaaa kayu che", index);
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };
  const pricingData = {
    user: {
      monthly: {
        free: "₹0",
        Starter: "₹850",
        pro: "₹1,360",
        elite: "₹40",
      },
      yearly: {
        free: "₹0",
        Starter: "₹680",
        pro: "₹1,088",
        elite: "₹400",
      },
    },
    team: {
      monthly: {
        free: "₹0",
        Starter: "₹34,999",
        pro: "₹74,999",
      },
      yearly: {
        free: "₹0",
        Starter: "₹34,999",
        pro: "₹74,999",
      },
    },
  };

  const elementRef = useRef(null);
  const tabRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const [isActives, setIsActives] = useState(false);
  const [selectedTitle, setSelectedTitle] = useState("Free");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Define complex content for each title
  const content = {
    Free: (
      <div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdChecklist className="text-indigo-600 text-lg" />
          Essentials
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Projects & Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("projectsone")}
                />
                {openTooltip === "projectsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organize your work with projects and task flows.
                  </div>
                )}
              </span>
              <span>50</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Storage
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("storageone")}
                />
                {openTooltip === "storageone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Secure cloud storage for all your documents, files, and
                    client work.
                  </div>
                )}
              </span>
              <span>500MB</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("clientsone")}
                />
                {openTooltip === "clientsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized client tracking to reduce follow-ups and
                    confusion.
                  </div>
                )}
              </span>
              <span>20</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Page History
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("pageone")}
                />
                {openTooltip === "pageone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Built-in audit trail for transparency and control.
                  </div>
                )}
              </span>
              <span>7 Days</span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdStar className="text-indigo-600 text-lg" />
          Core Features
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("dashboardsone")}
                />
                {openTooltip === "dashboardsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Interactive dashboards to monitor and manage your projects, tasks, and team metrics.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("multipledashboardsone")}
                />
                {openTooltip === "multipledashboardsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create and switch between multiple custom dashboards for different teams or workflows.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Inbox
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("inboxone")}
                />
                {openTooltip === "inboxone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized inbox to view all updates, notifications, and task assignments.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Favorites
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("favoritesone")}
                />
                {openTooltip === "favoritesone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Quickly access your most important projects, tasks, or files by marking them as favorites.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Trash
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("trashone")}
                />
                {openTooltip === "trashone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Recover deleted items or permanently remove them from your workspace.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Task Master Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskmastersettingsone")}
                />
                {openTooltip === "taskmastersettingsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Advanced configuration options to customize task behavior and workflow rules.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Status Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("statustemplatesone")}
                />
                {openTooltip === "statustemplatesone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Pre-defined or custom status workflows to track task progression efficiently.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Layout Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("layouttemplatesone")}
                />
                {openTooltip === "layouttemplatesone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Ready-to-use board, list, and table layouts for different types of projects.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Controls
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("usercontrolsone")}
                />
                {openTooltip === "usercontrolsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Manage user permissions, roles, and access rights across the workspace.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Analytical Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("analyticalsettingsone")}
                />
                {openTooltip === "analyticalsettingsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Configure parameters for tracking performance, time logs, and custom metrics.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Support Tickets
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("supportticketsone")}
                />
                {openTooltip === "supportticketsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Submit and track support requests directly from your workspace dashboard.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdDashboard className="text-indigo-600 text-lg" />
          Dashboard
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("dashone")}
                />
                {openTooltip === "dashone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organise your work visually — your way.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FiClipboard className="text-indigo-600 text-lg" />
          Projects & Tasks
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div "
            >
              <span className="flex items-center">
                Multiple Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("viewone")}
                />
                {openTooltip === "viewone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One project, many ways to visualize it.
                  </div>
                )}
              </span>
              <span>Only Tabular</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Assignees
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("assigneeone")}
                />
                {openTooltip === "assigneeone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Assign a task to multiple people — avoid finger-pointing.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Advanced Checklists
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("advancedone")}
                />
                {openTooltip === "advancedone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Smarter to-dos = smoother workflows.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Change Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("changeone")}
                />
                {openTooltip === "changeone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Say goodbye to WhatsApp edits and scattered feedback.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdOutlineNoteAlt className="text-indigo-600 text-lg" />
          Notes
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Powerful Note-taking
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("powerone")}
                />
                {openTooltip === "powerone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Notes that actually help you move work forward
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Notes Collaboration
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("notesone")}
                />
                {openTooltip === "notesone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Write together, decide faster.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsers className="text-indigo-600 text-lg" />
          Teams
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("teamsone")}
                />
                {openTooltip === "teamsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Define who leads what. Assign ownership clearly.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("leaderone")}
                />
                {openTooltip === "leaderone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One dashboard. Total leadership control.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaBuilding className="text-indigo-600 text-lg" />
          Office Hub
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("userrone")}
                />
                {openTooltip === "userrone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Let your team request what they need — transparently.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Attendance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("attendanceone")}
                />
                {openTooltip === "attendanceone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Track who's in and who's on leave — no spreadsheets.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Policies
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("policyone")}
                />
                {openTooltip === "policyone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Share your company rules in one searchable space.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <LuFileText className="text-indigo-600 text-lg" />
          Documents
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Documents Management
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("docsone")}
                />
                {openTooltip === "docsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Upload, tag, and organize all your files in one place.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("centricone")}
                />
                {openTooltip === "centricone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Files that follow users, not folders.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients Wise Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("wiseone")}
                />
                {openTooltip === "wiseone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organized by client, for clarity.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("chatone")}
                />
                {openTooltip === "chatone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Access files shared in chats — instantly.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaComments className="text-indigo-600 text-lg" />
          Chats
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Simplified Chat Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("setupone")}
                />
                {openTooltip === "setupone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Chat that knows the context of your task.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tempone")}
                />
                {openTooltip === "tempone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Perfect for onboarding, updates, and reminders.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Quick Messing Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("messingone")}
                />
                {openTooltip === "messingone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Jump between client, team, and project messages.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaCalendarAlt className="text-indigo-600 text-lg" />
          Calendars & Reminders
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clean and Powerful Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("policyone")}
                />
                {openTooltip === "cleanone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Visualize all your deadlines, reminders, and events.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Smart Reminders Integration with Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("remindersone")}
                />
                {openTooltip === "remindersone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Never forget again. Reminders that link back to work.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsersCog className="text-indigo-600 text-lg" />
          User & Client Management
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Easy User & Client Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("easyone")}
                />
                {openTooltip === "easyone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Less admin work. More insight.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Groups and Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("groupsone")}
                />
                {openTooltip === "groupsone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create groups and assign leaders in seconds.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Log Reports
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("logone")}
                />
                {openTooltip === "logone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get full visibility of team and client login sessions.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaFileInvoiceDollar className="text-indigo-600 text-lg" />
          Bill Flow (Task Invoicing)
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Work → Revenue
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskone")}
                />
                {openTooltip === "taskone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Turn missed tasks into tracked revenue.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaTools className="text-indigo-600 text-lg" />
          Utilities
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Task Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskuone")}
                />
                {openTooltip === "taskuone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Got Excel? You’ve got Simplifyte.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk User Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("buserone")}
                />
                {openTooltip === "buserone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Add your whole team in minutes.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Clients Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("cuserone")}
                />
                {openTooltip === "cuserone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Bring in all your clients in one shot.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Calendar Events Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("calenderone")}
                />
                {openTooltip === "calenderone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Import deadlines, events, and more from your sheet.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaMobileAlt className="text-indigo-600 text-lg" />
          Mobile App Access
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Access to full app (Users and Clients)
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("accessone")}
                />
                {openTooltip === "accessone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Work on the go, without compromise.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdBackup className="text-indigo-600 text-lg" />
          Data Backup
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Restoring of data in case of data loss.
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("restoreone")}
                />
                {openTooltip === "restoreone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Restore your work if anything goes wrong.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdSupportAgent className="text-indigo-600 text-lg" />
          Support
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Help center
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("helpone")}
                />
                {openTooltip === "helpone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Your support library, always open.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Email support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("esupportone")}
                />
                {openTooltip === "esupportone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    We respond, we don’t ghost.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                WhatsApp Support 24x7
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("whatsappone")}
                />
                {openTooltip === "whatsappone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get instant help anytime on WhatsApp.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Priority support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("psupportone")}
                />
                {openTooltip === "psupportone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Skip the queue — talk to experts.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Migration assistance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("migrationone")}
                />
                {openTooltip === "migrationone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Switch without the stress.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
      </div>
    ),
    Starter: (
      <div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdChecklist className="text-indigo-600 text-lg" />
          Essentials
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Projects & Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tasktwo")}
                />
                {openTooltip === "tasktwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organize your work with projects and task flows.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Storage
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("storagetwo")}
                />
                {openTooltip === "storagetwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Secure cloud storage for all your documents, files, and
                    client work.
                  </div>
                )}
              </span>
              <span>5 GB</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("three")}
                />
                {openTooltip === "three" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized client tracking to reduce follow-ups and
                    confusion.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Page History
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("four")}
                />
                {openTooltip === "four" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Built-in audit trail for transparency and control.
                  </div>
                )}
              </span>
              <span>30 Days</span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdStar className="text-indigo-600 text-lg" />
          Core Features
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("dashboardstwo")}
                />
                {openTooltip === "dashboardstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Interactive dashboards to monitor and manage your projects, tasks, and team metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("multipledashboardstwo")}
                />
                {openTooltip === "multipledashboardstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create and switch between multiple custom dashboards for different teams or workflows.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Inbox
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("inboxtwo")}
                />
                {openTooltip === "inboxtwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized inbox to view all updates, notifications, and task assignments.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Favorites
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("favoritestwo")}
                />
                {openTooltip === "favoritestwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Quickly access your most important projects, tasks, or files by marking them as favorites.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Trash
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("trashtwo")}
                />
                {openTooltip === "trashtwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Recover deleted items or permanently remove them from your workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Task Master Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskmastersettingstwo")}
                />
                {openTooltip === "taskmastersettingstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Advanced configuration options to customize task behavior and workflow rules.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Status Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("statustemplatestwo")}
                />
                {openTooltip === "statustemplatestwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Pre-defined or custom status workflows to track task progression efficiently.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Layout Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("layouttemplatestwo")}
                />
                {openTooltip === "layouttemplatestwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Ready-to-use board, list, and table layouts for different types of projects.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Controls
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("usercontrolstwo")}
                />
                {openTooltip === "usercontrolstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Manage user permissions, roles, and access rights across the workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Analytical Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("analyticalsettingstwo")}
                />
                {openTooltip === "analyticalsettingstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Configure parameters for tracking performance, time logs, and custom metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Support Tickets
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("supportticketstwo")}
                />
                {openTooltip === "supportticketstwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Submit and track support requests directly from your workspace dashboard.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdDashboard className="text-indigo-600 text-lg" />
          Dashboard
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("five")}
                />
                {openTooltip === "five" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organise your work visually — your way.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FiClipboard className="text-indigo-600 text-lg" />
          Projects & Tasks
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("six")}
                />
                {openTooltip === "six" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One project, many ways to visualize it.
                  </div>
                )}
              </span>
              <span>Multiple Views</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Assignees
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seven")}
                />
                {openTooltip === "seven" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Assign a task to mulDple people — avoid finger-poinDng.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Advanced Checklists
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eight")}
                />
                {openTooltip === "eight" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Smarter to-dos = smoother workflows.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Change Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("nine")}
                />
                {openTooltip === "nine" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Say goodbye to WhatsApp edits and scaHered feedback.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdOutlineNoteAlt className="text-indigo-600 text-lg" />
          Notes
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Powerful Note-taking
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ten")}
                />
                {openTooltip === "ten" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Notes that actually help you move work forward
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Notes collaboration
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eleven")}
                />
                {openTooltip === "eleven" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Write together, decide faster.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsers className="text-indigo-600 text-lg" />
          Teams
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twelve")}
                />
                {openTooltip === "twelve" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Define who leads what. Assign ownership clearly.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirteen")}
                />
                {openTooltip === "thirteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One dashboard. Total leadership control.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
              {/* <div className="pricing-popup">
                                <div className="name-desg-sec">
                                    <span className="name-sec">Use All core features of Simplifyte .</span>
                                </div>
                            </div> */}
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaBuilding className="text-indigo-600 text-lg" />
          Office Hub
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourteen")}
                />
                {openTooltip === "fourteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Let your team request what they need — transparently.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Attendance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fifteen")}
                />
                {openTooltip === "fifteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Track who's in and who's on leave — no spreadsheets.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Policies{" "}
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixteen")}
                />
                {openTooltip === "sixteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Share your company rules in one searchable space.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <LuFileText className="text-indigo-600 text-lg" />
          Documents
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Documents Management
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seventeen")}
                />
                {openTooltip === "seventeen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Upload, tag, and organize all your files in one place.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighteen")}
                />
                {openTooltip === "eighteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Files that follow users, not folders.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients Wise Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninteen")}
                />
                {openTooltip === "ninteen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organized by client, for clarity.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twenty")}
                />
                {openTooltip === "twenty" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Access files shared in chats — instantly.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaComments className="text-indigo-600 text-lg" />
          Chats
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Simplified Chat Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tone")}
                />
                {openTooltip === "tone" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Chat that knows the context of your task.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tonet")}
                />
                {openTooltip === "tonet" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Perfect for onboarding, updates, and reminders.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Quick Messing Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tonetwo")}
                />
                {openTooltip === "tonetwo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Jump between client, team, and project messages.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaCalendarAlt className="text-indigo-600 text-lg" />
          Calendars & Reminders
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clean and Powerful Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("oneo")}
                />
                {openTooltip === "oneo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Visualize all your deadlines, reminders, and events.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Smart Reminders Integration with Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twoo")}
                />
                {openTooltip === "twoo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Never forget again. Reminders that link back to work.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsersCog className="text-indigo-600 text-lg" />
          User & Client Management
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Easy User & Client Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("threeo")}
                />
                {openTooltip === "threeo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Less admin work. More insight.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Groups and Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fouro")}
                />
                {openTooltip === "fouro" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create groups and assign leaders in seconds.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Log Reports
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fiveo")}
                />
                {openTooltip === "fiveo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get full visibility of team and client login sessions.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaFileInvoiceDollar className="text-indigo-600 text-lg" />
          Bill Flow (Task Invoicing)
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Work → Revenue{" "}
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixo")}
                />
                {openTooltip === "sixo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Turn missed tasks into tracked revenue.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaTools className="text-indigo-600 text-lg" />
          Utilities
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Task Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seveno")}
                />
                {openTooltip === "seveno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Got Excel? You’ve got Simplifyte.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk User Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighto")}
                />
                {openTooltip === "eighto" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Add your whole team in minutes.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Clients Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("nineo")}
                />
                {openTooltip === "nineo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Bring in all your clients in one shot.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Calendar Events Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("teno")}
                />
                {openTooltip === "teno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Import deadlines, events, and more from your sheet.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaMobileAlt className="text-indigo-600 text-lg" />
          Mobile App Access
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Access to full app (Users and Clients)
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eleveno")}
                />
                {openTooltip === "eleveno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Work on the go, without compromise.
                  </div>
                )}
              </span>
              <BsCheck2 className="pricing-item-inner-div-check" />
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdBackup className="text-indigo-600 text-lg" />
          Data Backup
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Restoring of data in case of data loss.
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twelo")}
                />
                {openTooltip === "twelo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Restore your work if anything goes wrong.
                  </div>
                )}
              </span>
              <BsCheck2 className="pricing-item-inner-div-check" />
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdSupportAgent className="text-indigo-600 text-lg" />
          Support
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Help center
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thriteeno")}
                />
                {openTooltip === "thriteeno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Your support library, always open.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Email support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourteeno")}
                />
                {openTooltip === "fourteeno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    We respond, we don’t ghost.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                WhatsApp Support 24x7
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("whatsappo")}
                />
                {openTooltip === "whatsappo" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get instant help anytime on WhatsApp.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Priority support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fifteeno")}
                />
                {openTooltip === "fifteeno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Skip the queue — talk to experts.
                  </div>
                )}
              </span>
              <BsX className="pricing-item-inner-div-check cross-check" />
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Migration assistance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixteeno")}
                />
                {openTooltip === "sixteeno" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Switch without the stress.
                  </div>
                )}
              </span>
              <span>Talk to Sales</span>
            </li>
          </ul>
        </div>
      </div>
    ),
    Pro: (
      <div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdChecklist className="text-indigo-600 text-lg" />
          Essentials
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Projects & Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("onen")}
                />
                {openTooltip === "onen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organize your work with projects and task flows.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Storage
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twon")}
                />
                {openTooltip === "twon" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Secure cloud storage for all your documents, files, and
                    client work.
                  </div>
                )}
              </span>
              <span>10 GB</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("threen")}
                />
                {openTooltip === "threen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized client tracking to reduce follow-ups and
                    confusion.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Page History
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourn")}
                />
                {openTooltip === "fourn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Built-in audit trail for transparency and control.
                  </div>
                )}
              </span>
              <span>90 Days</span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdStar className="text-indigo-600 text-lg" />
          Core Features
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("dashboardsn")}
                />
                {openTooltip === "dashboardsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Interactive dashboards to monitor and manage your projects, tasks, and team metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("multipledashboardsn")}
                />
                {openTooltip === "multipledashboardsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create and switch between multiple custom dashboards for different teams or workflows.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Inbox
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("inboxn")}
                />
                {openTooltip === "inboxn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized inbox to view all updates, notifications, and task assignments.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Favorites
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("favoritesn")}
                />
                {openTooltip === "favoritesn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Quickly access your most important projects, tasks, or files by marking them as favorites.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Trash
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("trashn")}
                />
                {openTooltip === "trashn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Recover deleted items or permanently remove them from your workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Task Master Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskmastersettingsn")}
                />
                {openTooltip === "taskmastersettingsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Advanced configuration options to customize task behavior and workflow rules.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Status Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("statustemplatesn")}
                />
                {openTooltip === "statustemplatesn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Pre-defined or custom status workflows to track task progression efficiently.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Layout Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("layouttemplatesn")}
                />
                {openTooltip === "layouttemplatesn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Ready-to-use board, list, and table layouts for different types of projects.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Controls
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("usercontrolsn")}
                />
                {openTooltip === "usercontrolsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Manage user permissions, roles, and access rights across the workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Analytical Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("analyticalsettingsn")}
                />
                {openTooltip === "analyticalsettingsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Configure parameters for tracking performance, time logs, and custom metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Support Tickets
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("supportticketsn")}
                />
                {openTooltip === "supportticketsn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Submit and track support requests directly from your workspace dashboard.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdDashboard className="text-indigo-600 text-lg" />
          Dashboard
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fiven")}
                />
                {openTooltip === "fiven" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organise your work visually — your way.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FiClipboard className="text-indigo-600 text-lg" />
          Projects & Tasks
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixn")}
                />
                {openTooltip === "sixn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One project, many ways to visualize it.
                  </div>
                )}
              </span>
              <span>Multiple Views</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Assignees
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sevenn")}
                />
                {openTooltip === "sevenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Assign a task to multiple people — avoid finger-pointing.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Advanced Checklists
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eightn")}
                />
                {openTooltip === "eightn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Smarter to-dos = smoother workflows.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Change Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninen")}
                />
                {openTooltip === "ninen" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Say goodbye to WhatsApp edits and scattered feedback.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdOutlineNoteAlt className="text-indigo-600 text-lg" />
          Notes
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Powerful Note-taking
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tenn")}
                />
                {openTooltip === "tenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Notes that actually help you move work forward
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Notes collaboration
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("elevenn")}
                />
                {openTooltip === "elevenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Write together, decide faster.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsers className="text-indigo-600 text-lg" />
          Teams
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twelven")}
                />
                {openTooltip === "twelven" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Define who leads what. Assign ownership clearly.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirteenn")}
                />
                {openTooltip === "thirteenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One dashboard. Total leadership control.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
              {/* <div className="pricing-popup">
                                <div className="name-desg-sec">
                                    <span className="name-sec">Use All core features of Simplifyte .</span>
                                </div>
                            </div> */}
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaBuilding className="text-indigo-600 text-lg" />
          Office Hub
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourteenn")}
                />
                {openTooltip === "fourteenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Let your team request what they need — transparently.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Attendance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fifteenn")}
                />
                {openTooltip === "fifteenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Track who's in and who's on leave — no spreadsheets.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Policies{" "}
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixteenn")}
                />
                {openTooltip === "sixteenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Share your company rules in one searchable space.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <LuFileText className="text-indigo-600 text-lg" />
          Documents
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Documents Management
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seventeenn")}
                />
                {openTooltip === "seventeenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Upload, tag, and organize all your files in one place.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighterenn")}
                />
                {openTooltip === "eighterenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Files that follow users, not folders.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients Wise Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninteenn")}
                />
                {openTooltip === "ninteenn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organized by client, for clarity.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyn")}
                />
                {openTooltip === "twentyn" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Access files shared in chats — instantly.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaComments className="text-indigo-600 text-lg" />
          Chats
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Simplified Chat Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("onetf")}
                />
                {openTooltip === "onetf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Chat that knows the context of your task.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twotf")}
                />
                {openTooltip === "twotf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Perfect for onboarding, updates, and reminders.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Quick Messing Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("threetf")}
                />
                {openTooltip === "threetf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Jump between client, team, and project messages.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaCalendarAlt className="text-indigo-600 text-lg" />
          Calendars & Reminders
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clean and Powerful Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fouertf")}
                />
                {openTooltip === "fouertf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Visualize all your deadlines, reminders, and events.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Smart Reminders Integration with Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fivetf")}
                />
                {openTooltip === "fivetf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Never forget again. Reminders that link back to work.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsersCog className="text-indigo-600 text-lg" />
          User & Client Management
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Easy User & Client Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixtf")}
                />
                {openTooltip === "sixtf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Less admin work. More insight.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Groups and Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seventf")}
                />
                {openTooltip === "seventf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create groups and assign leaders in seconds.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Log Reports
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eightf")}
                />
                {openTooltip === "eightf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get full visibility of team and client login sessions.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaFileInvoiceDollar className="text-indigo-600 text-lg" />
          Bill Flow (Task Invoicing)
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Work → Revenue
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninetf")}
                />
                {openTooltip === "ninetf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Turn missed tasks into tracked revenue.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaTools className="text-indigo-600 text-lg" />
          Utilities
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Task Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tentf")}
                />
                {openTooltip === "tentf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Got Excel? You’ve got Simplifyte.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk User Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eleventf")}
                />
                {openTooltip === "eleventf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Add your whole team in minutes.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Clients Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twelvetf")}
                />
                {openTooltip === "twelvetf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Bring in all your clients in one shot.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Calendar Events Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirteentf")}
                />
                {openTooltip === "thirteentf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Import deadlines, events, and more from your sheet.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaMobileAlt className="text-indigo-600 text-lg" />
          Mobile App Access
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Access to full app (Users and Clients)
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourteenf")}
                />
                {openTooltip === "fourteenf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Work on the go, without compromise.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdBackup className="text-indigo-600 text-lg" />
          Data Backup
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Restoring of data in case of data loss.
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fifteenf")}
                />
                {openTooltip === "fifteenf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Restore your work if anything goes wrong.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdSupportAgent className="text-indigo-600 text-lg" />
          Support
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Help center
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixteenf")}
                />
                {openTooltip === "sixteenf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Your support library, always open.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Email support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seventeentf")}
                />
                {openTooltip === "seventeentf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    We respond, we don’t ghost.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                WhatsApp Support 24x7
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("whatsapptf")}
                />
                {openTooltip === "whatsapptf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get instant help anytime on WhatsApp.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Priority support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighteentf")}
                />
                {openTooltip === "eighteentf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Skip the queue — talk to experts.
                  </div>
                )}
              </span>
              <span>
                <BsX className="pricing-item-inner-div-check cross-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Migration assistance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninteentf")}
                />
                {openTooltip === "ninteentf" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Switch without the stress.
                  </div>
                )}
              </span>
              <span>Talk to Sales</span>
            </li>
          </ul>
        </div>
      </div>
    ),
    Elite: (
      <div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdChecklist className="text-indigo-600 text-lg" />
          Essentials
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Projects & Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("onee")}
                />
                {openTooltip === "onee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organize your work with projects and task flows.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Storage
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twoe")}
                />
                {openTooltip === "twoe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Secure cloud storage for all your documents, files, and
                    client work.
                  </div>
                )}
              </span>
              <span>Custom</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("threee")}
                />
                {openTooltip === "threee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized client tracking to reduce follow-ups and
                    confusion.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Page History
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("foure")}
                />
                {openTooltip === "foure" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Built-in audit trail for transparency and control.
                  </div>
                )}
              </span>
              <span>Unlimited</span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdStar className="text-indigo-600 text-lg" />
          Core Features
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("dashboardse")}
                />
                {openTooltip === "dashboardse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Interactive dashboards to monitor and manage your projects, tasks, and team metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("multipledashboardse")}
                />
                {openTooltip === "multipledashboardse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create and switch between multiple custom dashboards for different teams or workflows.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Inbox
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("inboxe")}
                />
                {openTooltip === "inboxe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Centralized inbox to view all updates, notifications, and task assignments.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Favorites
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("favoritese")}
                />
                {openTooltip === "favoritese" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Quickly access your most important projects, tasks, or files by marking them as favorites.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Trash
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("trashe")}
                />
                {openTooltip === "trashe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Recover deleted items or permanently remove them from your workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Task Master Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("taskmastersettingse")}
                />
                {openTooltip === "taskmastersettingse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Advanced configuration options to customize task behavior and workflow rules.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Status Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("statustemplatese")}
                />
                {openTooltip === "statustemplatese" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Pre-defined or custom status workflows to track task progression efficiently.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Layout Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("layouttemplatese")}
                />
                {openTooltip === "layouttemplatese" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Ready-to-use board, list, and table layouts for different types of projects.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Controls
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("usercontrolse")}
                />
                {openTooltip === "usercontrolse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Manage user permissions, roles, and access rights across the workspace.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Analytical Settings
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("analyticalsettingse")}
                />
                {openTooltip === "analyticalsettingse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Configure parameters for tracking performance, time logs, and custom metrics.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Support Tickets
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("supportticketse")}
                />
                {openTooltip === "supportticketse" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Submit and track support requests directly from your workspace dashboard.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdDashboard className="text-indigo-600 text-lg" />
          Dashboard
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Dashboards
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fivee")}
                />
                {openTooltip === "fivee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organise your work visually — your way.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FiClipboard className="text-indigo-600 text-lg" />
          Projects & Tasks
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixe")}
                />
                {openTooltip === "sixe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One project, many ways to visualize it.
                  </div>
                )}
              </span>
              <span>Multiple Views</span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Assignees
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sevene")}
                />
                {openTooltip === "sevene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Assign a task to multiple people — avoid finger-pointing.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Advanced Checklists
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighte")}
                />
                {openTooltip === "eighte" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Smarter to-dos = smoother workflows.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Change Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninee")}
                />
                {openTooltip === "ninee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Say goodbye to WhatsApp edits and scattered feedback.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdOutlineNoteAlt className="text-indigo-600 text-lg" />
          Notes
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Powerful Note-taking
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("tene")}
                />
                {openTooltip === "tene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Notes that actually help you move work forward
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Notes collaboration
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("elevene")}
                />
                {openTooltip === "elevene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Write together, decide faster.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsers className="text-indigo-600 text-lg" />
          Teams
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twelvee")}
                />
                {openTooltip === "twelvee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Define who leads what. Assign ownership clearly.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Team Leader Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirteene")}
                />
                {openTooltip === "thirteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    One dashboard. Total leadership control.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
              {/* <div className="pricing-popup">
                                <div className="name-desg-sec">
                                    <span className="name-sec">Use All core features of Simplifyte .</span>
                                </div>
                            </div> */}
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaBuilding className="text-indigo-600 text-lg" />
          Office Hub
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Requests
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fourteene")}
                />
                {openTooltip === "fourteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Let your team request what they need — transparently.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Attendance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("fifteene")}
                />
                {openTooltip === "fifteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Track who's in and who's on leave — no spreadsheets.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Policies{" "}
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("sixteene")}
                />
                {openTooltip === "sixteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Share your company rules in one searchable space.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <LuFileText className="text-indigo-600 text-lg" />
          Documents
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Documents Management
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("seventeene")}
                />
                {openTooltip === "seventeene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Upload, tag, and organize all your files in one place.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("eighteene")}
                />
                {openTooltip === "eighteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Files that follow users, not folders.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clients Wise Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("ninteene")}
                />
                {openTooltip === "ninteene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Organized by client, for clarity.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Centric Documents
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentye")}
                />
                {openTooltip === "twentye" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Access files shared in chats — instantly.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaComments className="text-indigo-600 text-lg" />
          Chats
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Simplified Chat Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyonee")}
                />
                {openTooltip === "twentyonee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Chat that knows the context of your task.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Chat Templates
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentytwoe")}
                />
                {openTooltip === "twentytwoe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Perfect for onboarding, updates, and reminders.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Multiple Quick Messing Views
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentythreee")}
                />
                {openTooltip === "twentythreee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Jump between client, team, and project messages.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaCalendarAlt className="text-indigo-600 text-lg" />
          Calendars & Reminders
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Clean and Powerful Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyfoure")}
                />
                {openTooltip === "twentyfoure" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Visualize all your deadlines, reminders, and events.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Smart Reminders Integration with Tasks
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyfivee")}
                />
                {openTooltip === "twentyfivee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Never forget again. Reminders that link back to work.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaUsersCog className="text-indigo-600 text-lg" />
          User & Client Management
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Easy User & Client Dashboard
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentysixe")}
                />
                {openTooltip === "twentysixe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Less admin work. More insight.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                User Groups and Team Leader Setup
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentysevene")}
                />
                {openTooltip === "twentysevene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Create groups and assign leaders in seconds.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Log Reports
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyeighte")}
                />
                {openTooltip === "twentyeighte" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get full visibility of team and client login sessions.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaFileInvoiceDollar className="text-indigo-600 text-lg" />
          Bill Flow (Task Invoicing)
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Work → Revenue
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("twentyninee")}
                />
                {openTooltip === "twentyninee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Turn missed tasks into tracked revenue.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaTools className="text-indigo-600 text-lg" />
          Utilities
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Task Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtye")}
                />
                {openTooltip === "thirtye" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Got Excel? You’ve got Simplifyte.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk User Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtyonee")}
                />
                {openTooltip === "thirtyonee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Add your whole team in minutes.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Clients Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtytwoe")}
                />
                {openTooltip === "thirtytwoe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Bring in all your clients in one shot.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Bulk Calendar Events Uploads
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtythreee")}
                />
                {openTooltip === "thirtythreee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Import deadlines, events, and more from your sheet.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <FaMobileAlt className="text-indigo-600 text-lg" />
          Mobile App Access
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Access to full app (Users and Clients)
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtyfoure")}
                />
                {openTooltip === "thirtyfoure" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Work on the go, without compromise.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdBackup className="text-indigo-600 text-lg" />
          Data Backup
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Restoring of data in case of data loss.
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtyfivee")}
                />
                {openTooltip === "thirtyfivee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Restore your work if anything goes wrong.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
          </ul>
        </div>
        <h6 className="flex items-center gap-2 font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
          <MdSupportAgent className="text-indigo-600 text-lg" />
          Support
        </h6>
        <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
          <ul className="list-none text-slate-400">
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Help center
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtysixe")}
                />
                {openTooltip === "thirtysixe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Your support library, always open.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Email support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtysevene")}
                />
                {openTooltip === "thirtysevene" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    We respond, we don’t ghost.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                WhatsApp Support 24x7
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("whatsappe")}
                />
                {openTooltip === "whatsappe" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Get instant help anytime on WhatsApp.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Priority support
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtyeighte")}
                />
                {openTooltip === "thirtyeighte" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Skip the queue — talk to experts.
                  </div>
                )}
              </span>
              <span>
                <BsCheck2 className="pricing-item-inner-div-check" />
              </span>
            </li>
            <li
              ref={tooltipRef}
              className="mb-3 flex items-center ms-0 pricing-item-inner-div"
            >
              <span className="flex items-center">
                Migration assistance
                <BsInfoCircle
                  className="ml-4 pricing-item-inner-div-info"
                  onClick={() => toggleTooltip("thirtyninee")}
                />
                {openTooltip === "thirtyninee" && (
                  <div className="mobile-tool-tip absolute mt-2 left-0 w-76 bg-white text-black text-sm p-3 shadow-lg rounded z-10">
                    Switch without the stress.
                  </div>
                )}
              </span>
              <span>Talk to Sales</span>
            </li>
          </ul>
        </div>
      </div>
    ),
  };

  const titles = Object.keys(content);

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setIsOpen((prev) => !prev);
  };

  const selectTitle = (title) => {
    setSelectedTitle(title);
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    // document.title = "Pricing - Simplifyte";
    const handleScroll = () => {
      if (!elementRef.current) return;
      const rect = elementRef.current.getBoundingClientRect();
      if (!isActive && rect.top < 88) {
        setIsActive(true);
      }
      if (isActive && rect.top > 79) {
        setIsActive(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isActive]);

  useEffect(() => {
    const handleScrolls = () => {
      if (window.innerWidth > 768) return; // only run on mobile screens
      if (!tabRef.current) return;
      const rects = tabRef.current.getBoundingClientRect();
      // console.log(rects.top);
      if (!isActives && rects.top < 90) {
        setIsActives(true);
      }
      if (isActives && rects.top > 89) {
        setIsActives(false);
      }
    };
    window.addEventListener("scroll", handleScrolls);

    return () => window.removeEventListener("scroll", handleScrolls);
  }, [isActives]);
  return (
    <>
      <Helmet>
        <title>Simplifyte Pricing Plans : Free, Starter, Pro, Elite</title>
        {/* Open Graph meta */}
        <meta
          property="og:title"
          content="Simplifyte Pricing Plans : From Setup to Success - Free, Starter, Pro, Elite"
        />
        <meta
          name="description"
          property="og:description"
          content="Streamline your workflow and accelerate growth with Simplifyte."
        />
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.simplifyte.com/pricing" />
        {/* Viewport for responsive design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        clg
        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Simplifyte pricing, Free plan, Starter plan, Pro plan, Elite plan, affordable business tools, subscription pricing, SaaS pricing"
        />
      </Helmet>
      <div>
        <HeaderMenu />
        <section className="relative md:py-24 py-36 pricing-page">
          <div className="container relative">
            <div className="grid grid-cols-1 pb-8 text-center">
              {/* font-size-same mb-2 md:text-3xl md:leading-normal text-2xl leading-normal font-bold */}
              <h1 className="Pricing_Main_Class">From Setup to Success</h1>
              {/* sub-desc-css text-slate-400 max-w-xl mx-auto  */}
              <p className="Pricing_Main_Para_Class">
                Streamline your workflow and accelerate growth with
                <span className="text-[#093a5b] font-extrabold"> Simpli</span>
                <span className="text-[#329BD7] text-[15px]">fyte</span>
              </p>
            </div>

            <div className="grid grid-cols-1">
              {/* className="inline-block w-fit mx-auto flex-wrap justify-center text-center p-2 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-full" */}
              <PricingCards
                handleToggle={handleToggle}
                isMonthly={isMonthly}
                setIsMonthly={setIsMonthly}
                isOpenTab={isOpenTab}
                hhandleToggle={hhandleToggle}
                isMMonthly={isMMonthly}
                handleTabClick={handleTabClick}
                tabRef={tabRef}
                isActives={isActives}
              />
              <ProofBlock />
              {/* <div className="relative">
              </div> */}
              <div className="grid grid-cols-1 pb-8 text-center">
                <h1 className="Pricing_Main_Class">From Setup to Success</h1>
                <p className="Pricing_Main_Para_Class">
                  Streamline your workflow and accelerate growth with
                  Simplifyte.
                </p>
              </div>
              <div className="web-view-section">
                <DynamicPricing />
                <div id="StarterContent">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdChecklist className="text-indigo-600 text-lg" />
                      Essential
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Projects & Tasks</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Organize work using projects, tasks, and
                                  structured task flows.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Storage</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Secure space available for files, documents,
                                  and related uploads.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Clients</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Manage and organize unlimited client records
                                  in your workspace.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Page History</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Access previous versions and restore changes
                                  made over time.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      {/* 
                      <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            50
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            500 MB
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            20
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            7 days
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            1 GB
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            30 days
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            5 GB
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            90 days
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            10 GB
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            {" "}
                            Unlimited
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdStar className="text-indigo-600 text-lg" />
                      Core Features
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Dashboards</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Interactive dashboards to monitor and manage your projects, tasks, and team metrics.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Multiple Dashboards</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Create and switch between multiple custom dashboards for different teams or workflows.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Inbox</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Centralized inbox to view all updates, notifications, and task assignments.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Favorites</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Quickly access your most important projects, tasks, or files by marking them as favorites.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Trash</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Recover deleted items or permanently remove them from your workspace.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Task Master Settings</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Advanced configuration options to customize task behavior and workflow rules.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Status Templates</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Pre-defined or custom status workflows to track task progression efficiently.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Layout Templates</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Ready-to-use board, list, and table layouts for different types of projects.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>User Controls</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Manage user permissions, roles, and access rights across the workspace.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Analytical Settings</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Configure parameters for tracking performance, time logs, and custom metrics.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Support Tickets</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Submit and track support requests directly from your workspace dashboard.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsX className="pricing-item-inner-div-check cross-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div"><BsCheck2 className="pricing-item-inner-div-check" /></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdDashboard className="text-indigo-600 text-lg" />
                      Dashboard
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Multiple Dashboards</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Create and switch between different dashboards
                                  for different workflows or teams.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FiClipboard className="text-indigo-600 text-lg" />
                      Projects & Tasks
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Task Workflow System</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Structured task flows to manage work from
                                  start to completion.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Multiple Tasks Views</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  View work in different layouts for easier
                                  planning and tracking.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Multiple Assignees</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Assign one task to multiple team members where
                                  needed.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Sub-tasks</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Break larger tasks into smaller actionable
                                  parts.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Different View (Table / Calendar / Capsule View)</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Switch between Table, Calendar, and Capsule
                                  views for flexible project visualization.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdChecklist className="text-indigo-600 text-lg" />
                      Checklists
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Checklists</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Add simple checklists inside tasks to track
                                  step-by-step progress.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Advance Checklists</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Smarter to-dos with assignees, due dates, and
                                  structured execution flows.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* Starter */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      {/* Pro */}
                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>

                      {/* Elite */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdOutlineNoteAlt className="text-indigo-600 text-lg" />
                      Private Notes
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Powerful Note-taking</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Create rich notes for personal work,
                                  documentation, and daily execution.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Notes Collaboration</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Work on notes together with your team in
                                  shared mode.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaUsers className="text-indigo-600 text-lg" />
                      Teams
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Team Lead Setup</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Assign team leads for supervision, review, and
                                  workflow control.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Team Lead Dashboard</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Give team leads a focused dashboard to manage
                                  team work and approvals.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      {/* 
                      <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaBuilding className="text-indigo-600 text-lg" />
                      Office Hub
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>User Requests</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Manage internal requests raised by team
                                  members in one place.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Attendance</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Track attendance and related team records
                                  inside the workspace.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Policies</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Store and access office policies for team
                                  reference.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Timesheets</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Record and manage time entries for work done
                                  by users.
                                </span>
                              </div>
                            </div>
                          </li>{" "}
                          {/* <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Logged Devices</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  View devices used to access the workspace for
                                  monitoring and control.
                                </span>
                              </div>
                            </div>
                          </li> */}
                        </ul>
                      </div>
                      {/* 
                      <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <LuFileText className="text-indigo-600 text-lg" />
                      Documents
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Documents Management</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Upload, organize, and manage files across your
                                  workspace.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>User Centric Documents</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Keep documents mapped user-wise for easier
                                  access and tracking.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Client Wise Documents</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Organize files client-wise for faster
                                  retrieval and cleaner records.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Client Access Toggle</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Control whether clients can access specific
                                  documents or areas.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaComments className="text-indigo-600 text-lg" />
                      Chats
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Simplified Chat Setup</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Use structured chats inside the workspace
                                  instead of scattered communication.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Chat Templates</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Save and reuse common communication formats
                                  for faster messaging.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Multiple Quick Messaging Views</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Switch between different quick chat views for
                                  faster follow-ups.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> 

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaCalendarAlt className="text-indigo-600 text-lg" />
                      Calendars & Reminders
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Calendar Dashboard</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  View deadlines, events, and schedules in one
                                  calendar-based dashboard.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Reminders Dashboard</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Never forget again. Reminders that link back
                                  to work.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Expiring Task Reminders</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Never forget again. Reminders that link back
                                  to work.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaUsersCog className="text-indigo-600 text-lg" />
                      User & Client Management
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Easy User & Client Dashboard</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Less admin work. More insight.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>User Groups and Team Leader Setup</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Create groups and assign leaders in seconds.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Log Reports</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Get full visibility of team and client login
                                  sessions.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Value Analysis</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Measure growth, efficiency, and business
                                  impact with smart analytics.
                                </span>
                              </div>
                            </div>
                          </li>{" "}
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Work Utilities </span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Manage daily operations smoothly using
                                  powerful work tools.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Clients Login</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Allow clients to log in and access their
                                  dedicated workspace area.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaFileInvoiceDollar className="text-indigo-600 text-lg" />
                      Bill Flow
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Client Wise Bill Flow / Task Invoicing</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Turn completed tasks into invoices, organized
                                  by client.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Clients Group Wise Bill Flow / Task Invoicing</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Generate grouped invoices across multiple
                                  clients for streamlined billing.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* Starter */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      {/* Pro */}
                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>

                      {/* Elite */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaTools className="text-indigo-600 text-lg" />
                      Utilities
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div master_margin">
                            <span>Bulk Task Uploads</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Got Excel? You’ve got Simplifyte.
                                </span>
                              </div>
                            </div>
                          </li>
                          {/* <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Bulk User Uploads</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Add your whole team in minutes.
                                </span>
                              </div>
                            </div>
                          </li> */}
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Bulk Client Uploads</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Bring in all your clients in one shot.
                                </span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Bulk Calendar Events Uploads</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">
                                  Import deadlines, events, and more from your
                                  sheet.
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      {/* <div className="basic-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div> */}

                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          {/* <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li> */}
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                        </ul>
                      </div>

                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          {/* <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li> */}
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          {/* <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li> */}
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile App Access */}
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <FaMobileAlt className="text-indigo-600 text-lg" />
                      Mobile App Access
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Access to full app (Users and Clients)</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Work on the go, without compromise.</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Data Backup */}
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdBackup className="text-indigo-600 text-lg" />
                      Data Backup
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Restoring of data in case of data loss</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Restore your work if anything goes wrong.</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Support */}
                <div id="StarterContent" className="mt-6">
                  <div>
                    <h6 className="flex items-center gap-2 titles-sticky font-bold uppercase mb-6 mt-6 text-indigo-600 feature-title">
                      <MdSupportAgent className="text-indigo-600 text-lg" />
                      Support
                    </h6>
                    <div className="grid lg:grid-cols-4 md:grid-cols-2 mt-6 gap-[30px]">
                      <div className="free-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Help center</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Your support library, always open.</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Email support</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">We respond, we don't ghost.</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>WhatsApp Support 24x7</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Get instant help anytime on WhatsApp.</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Priority support</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Skip the queue — talk to experts.</span>
                              </div>
                            </div>
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <span>Migration assistance</span>
                            <span className="info-popup">
                              <BsInfoCircle className="pricing-item-inner-div-info" />
                            </span>
                            <div className="pricing-popup">
                              <div className="name-desg-sec">
                                <span className="name-sec">Switch without the stress.</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      {/* Starter */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            Talk to Sales
                          </li>
                        </ul>
                      </div>
                      {/* Pro */}
                      <div className="business-content group border-b-[3px] border-indigo-600 px-1 p-6 py-8 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl bg-white dark:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsX className="pricing-item-inner-div-check cross-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            Talk to Sales
                          </li>
                        </ul>
                      </div>
                      {/* Elite */}
                      <div className="enterprise-content group border-b-[3px] p-6 py-8 hover:border-indigo-600 transition-all duration-500 ease-in-out hover:scale-105 relative  shadow dark:shadow-gray-800 rounded-xl  hover:bg-white dark:hover:bg-slate-900 h-fit">
                        <ul className="list-none text-slate-400">
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            <BsCheck2 className="pricing-item-inner-div-check" />
                          </li>
                          <li className="mb-3 flex items-center ms-0 pricing-item-inner-div">
                            Talk to Sales
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mobile-view-section">
                <div className="mobile-box">
                  {/* Dropdown */}
                  {/* <div className="m-width my-5"> */}
                  <div
                    ref={elementRef}
                    className={`m-width my-5 my-element ${isActive ? "active" : ""
                      }`}
                  >
                    <button
                      onClick={toggleDropdown}
                      className="pad-t w-full flex items-center justify-between px-4 py-2 bg-indigo-100 text-indigo-600 font-bold uppercase rounded-xl hover:bg-indigo-200"
                    >
                      {selectedTitle}
                      {isOpen ? (
                        <ChevronUp className="w-4 h-4" />
                      ) : (
                        <ChevronDown className="w-4 h-4" />
                      )}
                    </button>
                    {isDropdownOpen && (
                      <div className="absolute w-full mt-2 bg-white border border-gray-300 rounded-xl shadow-lg m-dropdown">
                        <ul className="text-sm text-gray-700">
                          {titles.map((title) => (
                            <li
                              key={title}
                              onClick={() => selectTitle(title)}
                              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            >
                              {title}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Content Display */}
                  <div className="feature-content">
                    {content[selectedTitle]}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            className="relative overflow-hidden"
            style={{ marginTop: "30px" }}
          >
            <div className="container relative md:mt-12 mt-12">
              <div className="grid md:grid-cols-2 grid-cols-1 items-end">
                <div className="relative order-1 md:order-2 c-padding">
                  <img src={faq} className="rounded-lg" alt="Simplifyte" />
                </div>

                <div className="lg:me-8 order-2 md:order-1 mrgin-out">
                  {/* font-size-same mb-4 md:text-3xl text-2xl lg:leading-normal leading-normal font-semibold c-margin  */}
                  <h4 className="Pricing_Class_Support">
                    If you need help, <br /> we're here for you
                  </h4>

                  <div
                    id="accordion-collapseone"
                    data-accordion="collapse"
                    className="mt-6 scrollable-faq"
                  >
                    {accordionData.slice(0, 11).map((item, index) => (
                      <div
                        key={index}
                        className="relative shadow dark:shadow-gray-800 rounded-xl overflow-hidden mt-4"
                      >
                        <h2
                          className="text-base font-semibold"
                          id="accordion-collapse-heading-1"
                        >
                          <button
                            type="button"
                            onClick={() => toggleAccordion(index)}
                            className={`flex justify-between items-center p-5 w-full font-medium text-start ${activeIndex === index
                              ? "bg-gray-50 dark:bg-slate-800 text-indigo-600"
                              : ""
                              }`}
                            data-accordion-target="#accordion-collapse-body-1"
                            aria-expanded="true"
                            aria-controls="accordion-collapse-body-1"
                          >
                            <span>{item.title}</span>
                            <svg
                              data-accordion-icon
                              className={`${activeIndex === index
                                ? "rotate-180"
                                : "rotate-270"
                                } size-4 shrink-01`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </h2>
                        {activeIndex === index && (
                          <div>
                            <div className="p-5">
                              <p className="text-slate-400 dark:text-gray-400">
                                {item.content}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <ContactInTouch title={true} /> */}
          <Onboard />
        </section>

        <CustomFooter />
      </div>
    </>
  );
}
